import { Box, Grid, Typography } from '@mui/material';
import { isEmpty } from 'lodash';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ButtonBack from 'src/components/common/ButtonBack';
import MainContainer from 'src/components/common/MainContainer';
import ListPrediction from 'src/features/AIHSCodeLabeling/Common/ListPrediction';
import ListPredictionSkeleton from 'src/features/AIHSCodeLabeling/Common/ListPredictionSkeleton';
import QuickViewPanel from 'src/features/AIHSCodeLabeling/Common/QuickViewPanel';
import RelatedHsCode from 'src/features/AIHSCodeLabeling/Common/RelatedHsCode';
import FormAdjustment from 'src/features/AIHSCodeLabeling/FormAdjustment';
import MainLayout from 'src/layouts';
import { AuthRouteKeys } from 'src/utils/constants/routes';
import { useSingleHSCodePredictionStore } from 'src/zustand/useAILabelingStore';

const SinglePrediction = () => {
  const [selected, setSelected] = useState<undefined | TypeSingleHSCodePrediction>(undefined);
  const { isLoadingAIMatch } = useSingleHSCodePredictionStore();
  const { resetStore } = useSingleHSCodePredictionStore();
  const navigate = useNavigate();

  return (
    <MainLayout>
      <MainContainer>
        <ButtonBack
          onClick={() => {
            resetStore();
            navigate(AuthRouteKeys.AIHSCodeSearch);
          }}
        />

        <FormAdjustment />

        <Typography mt={3} variant="h5" mb={1}>
          AI HS Code Prediction with Confidence
        </Typography>
        <Typography mb={3} color={'text.secondary'} variant="body2">
          Our AI analyses your input to estimate the most likely results, based on customs declarations using similar
          terminology. To refine these results you may wish to include additional details (usage, technical
          specifications etc).
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={8}>
            {isLoadingAIMatch ? (
              <ListPredictionSkeleton />
            ) : (
              <ListPrediction selected={selected} onSelect={setSelected} />
            )}
          </Grid>
          <Grid item xs={4}>
            {selected && <QuickViewPanel selected={selected} />}
            <Box mt={3} />
            {!isEmpty(selected?.related_hscodes) && <RelatedHsCode selected={selected} />}
          </Grid>
        </Grid>
      </MainContainer>
    </MainLayout>
  );
};

export default SinglePrediction;
